import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  ElementRef
} from '@angular/core';

// Servicios
import { DragulaService } from 'ng2-dragula';
// Components
import { SxBaseContainerDesigner } from '../../base/base-container-designer-component';
import {
  DesignAttributeType,
  OptionsAttribute
} from '../../../../types/designer-attribute-type';
import { IDesignerFactoryService } from '../../../../services/designer-factory-interface';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'sx-group-designer',
  templateUrl: './group.designer.component.html'
})
export class SxGroupDesigner extends SxBaseContainerDesigner
  implements OnInit, OnDestroy {
  @ViewChild('groupPanelContainer', { read: ViewContainerRef })
  private groupPanelContainer: ViewContainerRef;

  constructor(
    dragulaService: DragulaService,
    designerFactoryService: IDesignerFactoryService,
    container: ElementRef,
    public ngxSmartModalService: NgxSmartModalService
  ) {
    super(dragulaService, designerFactoryService, 'SxGroup', container);
  }

  loadDefaults(): void {
    super.loadDefaults();
    this.controlContext.title = '';
  }

  getElementModal(instance: any) {
    this.ngxSmartModalService.setModalData(instance, 'attributesModal');
    this.ngxSmartModalService.getModal('attributesModal').open();
  }

  getDesignerInfo(): any {
    const info = super.getDesignerInfo();

    info['title'] = this.controlContext.title;
    info['asyncDisplayDependency'] = this.controlContext.asyncDisplayDependency;

    return info;
  }

  buildAttributes(): void {
    super.buildAttributes();

    const titleAtt = new DesignAttributeType(
      this.controlContext,
      'string',
      'title'
    );
    const asyncDependenciesAtt = new DesignAttributeType(
      this.controlContext,
      'string',
      'asyncDisplayDependency',
      'Async display dependency'
    );

    this.attributes.push(
      titleAtt,
      asyncDependenciesAtt,
    );
  }

  ngOnInit(): void {
    this.placeHolderContainer = this.groupPanelContainer;
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/containers/group.designer.component.ts